import { ErrorModalTypes } from '@Store/index';
import { Icons } from '@Components/icon/Icon';
import { ErrorType } from './errorType';
import type { IErrorHandling } from '@Types/types';

export const VerificationCenterErrorMap = {
  ILLEGAL_FILE_TYPE: { errorCode: 80002, errorType: ErrorType.BUSINESS_LOGIC },
  BAD_PDF_FORMAT: { errorCode: 90211, errorType: ErrorType.BUSINESS_LOGIC },
};

export const getVerificationCenterErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      VerificationCenterErrorMap.ILLEGAL_FILE_TYPE.errorCode,
      {
        errorCode: VerificationCenterErrorMap.ILLEGAL_FILE_TYPE.errorCode,
        callBack: () => {},
        openModal: true,
        modalProps: {
          type: ErrorModalTypes.GENERAL,
          title: 'Unsupported File Format',
          content: 'This file type isn’t supported. Please upload a valid PDF, JPG, or PNG file.',
          icon: Icons.Oops,
          buttonText: 'Close',
        },
      },
    ],
    [
      VerificationCenterErrorMap.BAD_PDF_FORMAT.errorCode,
      {
        errorCode: VerificationCenterErrorMap.BAD_PDF_FORMAT.errorCode,
        callBack: () => {},
        openModal: true,
        modalProps: {
          type: ErrorModalTypes.GENERAL,
          title: 'Invalid PDF File',
          content:
            'We couldn’t read this PDF. Please upload a valid PDF file, or try saving it again and re-uploading.',
          icon: Icons.Oops,
          buttonText: 'Close',
        },
      },
    ],
  ]);
};
